var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextGeneric(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TextGeneric") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table/Table-Row-2/Table-Row-TBA-Compare",
    transform: "translate(-602.000000, -14.000000)",
    fill: "#ABB1BA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DescriptionText",
    transform: "translate(602.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,14 L0,12 L10,12 L10,14 L0,14 Z M0,10 L0,8 L16,8 L16,10 L0,10 Z M0,6 L0,4 L16,4 L16,6 L0,6 Z M0,2 L0,0 L16,0 L16,2 L0,2 Z",
    id: "TextGeneric"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextGeneric);
export default __webpack_public_path__ + "static/media/TextGeneric.644a3e36.svg";
export { ForwardRef as ReactComponent };